import { createFileRoute, redirect } from '@tanstack/react-router';

/** Removed from catalog POC — keep stub so stale routeTree regenerations don't break. */
export const Route = createFileRoute('/solution/$slug')({
  beforeLoad: () => {
    throw redirect({ to: '/products', replace: true });
  },
});
